import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { FormModel } from "projects/assist/src/app/_shared/form/form-models/form-model";

export class DummyFormModel extends FormModel<DummyData> {
  constructor(
    model: DummyData,
    readonly fb: FormBuilder = new FormBuilder()
  ) {
    super(
      model,
      fb.group({
        Option: [model.Option],
        OptionRequired: [model.Option, Validators.required],
        Value: [model.Value],
        ValueRequired: [model.Value, Validators.required],
        Number: [model.Number],
        NumberRequired: [model.Number, Validators.required],
      }).controls
    );
  }

  readonly Option = this.get("Option") as FormControl;
  readonly OptionRequired = this.get("OptionRequired") as FormControl;
  readonly Value = this.get("Value") as FormControl;
  readonly ValueRequired = this.get("ValueRequired") as FormControl;
  readonly Number = this.get("Number") as FormControl;
  readonly NumberRequired = this.get("NumberRequired") as FormControl;
}
export class DummyData {
  Option: string | null = null;
  Value: string = "";
  Number: number = 0;
}
